import * as React from 'react'

const AnchorContext = React.createContext(null as any)

export default AnchorContext
